<template>
  <div class="board-crumb">
    <router-link to="/data-analytics">数据中心</router-link>

    <template v-if="groupId">
      <span>/</span>
      <strong v-if="level === 'matrix'">{{ displayName }}</strong>
      <router-link v-else :to="matrixTo">{{ displayName }}</router-link>
    </template>
    <template v-else-if="level === 'matrix'">
      <span>/</span>
      <em>矩阵超级看板</em>
    </template>

    <template v-if="platform && level !== 'matrix'">
      <span>/</span>
      <strong v-if="level === 'platform'">{{ platLabel }}</strong>
      <router-link v-else-if="groupId" :to="platformTo">{{ platLabel }}</router-link>
      <em v-else>{{ platLabel }}</em>
    </template>

    <template v-if="accountLabel && (level === 'account' || level === 'item')">
      <span>/</span>
      <strong v-if="level === 'account'">{{ accountLabel }}</strong>
      <router-link v-else :to="accountTo">{{ accountLabel }}</router-link>
    </template>

    <template v-if="level === 'item' && itemLabel">
      <span>/</span>
      <strong>{{ itemLabel }}</strong>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import {
  matrixGroupLink,
  platformGroupLink,
  accountBoardLink,
  platformLabel,
  resolveGroupName,
} from '../utils/boardNav'

const props = defineProps({
  /** matrix | platform | account | item */
  level: { type: String, required: true },
  platform: { type: String, default: '' },
  groupId: { type: [String, Number], default: '' },
  groupName: { type: String, default: '' },
  range: { type: [String, Number], default: '' },
  accountId: { type: String, default: '' },
  accountLabel: { type: String, default: '' },
  itemLabel: { type: String, default: '' },
})

const gid = computed(() => String(props.groupId || '').trim())
const displayName = computed(() => resolveGroupName({ groupName: props.groupName }, gid.value))
const platLabel = computed(() => platformLabel(props.platform))
const rangeVal = computed(() => (props.range != null && props.range !== '' ? props.range : undefined))

const matrixTo = computed(() => matrixGroupLink(gid.value, rangeVal.value))
const platformTo = computed(() => platformGroupLink(props.platform, gid.value, rangeVal.value))
const accountTo = computed(() =>
  accountBoardLink(props.platform, props.accountId, {
    group: gid.value,
    fromGroup: gid.value,
    groupName: props.groupName,
    range: rangeVal.value,
  }),
)
</script>

<style scoped>
.board-crumb {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  color: var(--mp-text-muted);
  font-size: 13px;
}
.board-crumb a {
  color: var(--mp-accent);
  text-decoration: none;
}
.board-crumb a:hover {
  color: var(--mp-accent-hover);
}
.board-crumb strong {
  color: var(--mp-text);
  font-weight: 700;
}
.board-crumb em {
  font-style: normal;
  color: var(--mp-text-secondary);
}
</style>
